import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { SessionService } from "../core/storage/session.service";
import { MenuItem } from "../shared/menu/menu-item.model";
import { MenuService } from "../shared/menu/menu.service";
import { PlatformService } from "./platform.service";

@Component({
  selector: "app-platform",
  templateUrl: "./platform.component.html",
  styleUrls: ["./platform.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlatformComponent implements OnInit {
  isOpen = false;
  items: MenuItem[] = [];

  constructor(
    private platformService: PlatformService,
    private menuService: MenuService,
    private sessionService: SessionService,
    private changeDetector: ChangeDetectorRef) { }

  ngOnInit() {
    this.menuService.isOpen$.subscribe(value => this.isOpen = value);
    this.platformService
      .getMenu()
      .subscribe(this.assignAndNotifyMenuItems);
  }

  private assignAndNotifyMenuItems = (data): void => {
    this.sessionService.put("user_menus", JSON.stringify(data));
    this.items = data;
    this.changeDetector.markForCheck();
  }
}
